import { useTranslation } from 'react-i18next';
import { IconNames } from '@anytag/shared-assets';
import { TikTokProductCategory, TikTokProductCategoryName, useAllTiktokProductCategoryQuery } from '@anytag/graphql';

const PRODUCT_CATEGORY_ICONS: Record<TikTokProductCategoryName, IconNames> = {
  [TikTokProductCategoryName.LIFESTYLE]: 'lamp-colors',
  [TikTokProductCategoryName.FMCG]: 'shopping-colors',
  [TikTokProductCategoryName.FASHION]: 't-shirt-colors',
  [TikTokProductCategoryName.ELECTRONIC]: 'headphones-colors',
  [TikTokProductCategoryName.BEAUTY]: 'cosmetics-colors',
  [TikTokProductCategoryName.OTHERS]: 'gift-colors'
};

export const useTikTokProductCategories = () => {
  const { t } = useTranslation();
  const { data, loading } = useAllTiktokProductCategoryQuery({ fetchPolicy: 'cache-and-network' });

  const allTiktokProductCategory = data?.allTiktokProductCategory || [];
  const productCategories = allTiktokProductCategory.length
    ? (Object.keys(PRODUCT_CATEGORY_ICONS) as TikTokProductCategoryName[]).reduce(
        (acc, curr) => {
          const matchedProductCategory = allTiktokProductCategory.find((product) => product.name === curr);

          if (matchedProductCategory) {
            acc.push({
              ...matchedProductCategory,
              label: t<string>(`Product.${curr}`),
              icon: PRODUCT_CATEGORY_ICONS[curr]
            });
          }

          return acc;
        },
        [] as (TikTokProductCategory & { label: string; icon: IconNames })[]
      )
    : [];

  return { loading, productCategories };
};
